// Кириллица
import {BitrixVue} from 'ui.vue3'
import {createPinia, mapWritableState, mapState, mapActions} from 'ui.vue3.pinia'
import {menuStore} from './store'
import {MainItem} from './MainItem'

export class DynamicMenu {
    constructor(containerID, options) {
        this.$appContainer = document.getElementById(containerID)
        options.ITEMS.forEach((item) => {
            item.isShow = false
            if (item.col5) {
                item.col5.forEach(el => el.isShow = true)
            }

            item.children.forEach((itemL2) => {
                itemL2.isShow = false
            })
        });

        const application = BitrixVue.createApp({
            created() {
                this.items_list = options.ITEMS;
                this.sales = options.SALE;
                this.additional_sale = options.ADDITIONAL_SALE;
                this.banners = options.BANNERS;
                this.menu_utp = options.MENU_UTP;
                this.menu_special = options.MENU_SPECIAL;

                this.checkMobile();
                window.addEventListener('resize', () => {
                    this.checkMobile();
                });
            },
            components: {
                MainItem,
            },
            computed: {
                ...mapWritableState(menuStore, ['items_list', 'sales', 'additional_sale', 'banners', 'isMobile', 'menu_utp']),
                ...mapState(menuStore, ['items', 'parent']),
                isOpenSubMenu() {
                    let result = false
                    let isActiveItem = this.items.find(item => item.isShow);
                    if (isActiveItem && !this.parent) {
                        result = true
                    }
                    return result
                },
            },
            methods: {
                ...mapActions(menuStore, ['closeMenu']),
                checkMobile() {
                    if (window.innerWidth < 1361) {
                        this.isMobile = true;
                    } else {
                        this.isMobile = false;
                    }
                },
            },
            // language=Vue
            template: `
              <div class="header-nav-main-unit header-nav-main-unit_upper" @click="closeMenu" :class="{open: isOpenSubMenu}">
              <a class="header-nav-main-unit-title prev" href="#/">Меню</a>
              </div>
              <MainItem v-for="(ar1Item, key) in items" :item="ar1Item" :index="key"/>
              <div class="header-nav-main-unit--special" v-html="menu_special"></div>
            `,
        })
        application.use(createPinia());
        application.mount(this.$appContainer)
    }
}